module.exports = __webpack_public_path__ + "img/video_play.faa17efe.svg";